exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/pem1hfh.css);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);

// module
exports.push([module.id, ".PopupContainer.fixed {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 400;\r\n  width: 300px;\r\n  padding: 10px;\r\n  margin: 20px;\r\n  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);\r\n  background-color: #ffffff;\r\n  border-radius: 12px; }\r\n\r\n.mobile .PopupContainer {\r\n  position: absolute;\r\n  bottom: 0;\r\n  z-index: 400;\r\n  width: calc(100% - 20px);\r\n  margin: 0 10px 10px 10px; }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/scenes/MapContainer/components/PopupContainer/PopupContainer.css
// module id = 861
// module chunks = 0